import type { Resolver } from 'cpool-schemas';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

import { TeamsTableDefinitionZod } from '../../team/tables';
import { NonSensitiveUsersTableDefinitionZod, UserGroupContextZod } from '../tables';

type Arguments = {
    position?: number;
    corporationPosition?: number;
    divisionId?: string | null;
};

export const schemaUserResolver_GetDivisionsByUserId = z.record(
    z.array(
        z.object({
            team: TeamsTableDefinitionZod.extend({ corporationId: schemaId }),
            teamLeader: NonSensitiveUsersTableDefinitionZod.merge(UserGroupContextZod).nullable(),
            teamMembers: z.array(NonSensitiveUsersTableDefinitionZod.merge(UserGroupContextZod)),
        }),
    ),
);

export type SchemaUserResolver_GetDivisionsByUserId = z.infer<typeof schemaUserResolver_GetDivisionsByUserId>;

export type UserResolver_GetDivisionsByUserId = Resolver<Arguments, SchemaUserResolver_GetDivisionsByUserId>;
